import React, {
  useState
} from "react";

import {
  useDispatch,
  useSelector
} from "react-redux";

import {
 useHistory,
  Link
} from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { loginAction, sendOtpAction } from "../../../store/actions/authActions/authActions";


export default function LoginPage() {

  const dispatch =
    useDispatch();

  const history =useHistory();

const loading =
    useSelector(
      state =>
        state?.auth?.loading||null
    );
  const [tab, setTab] =
    useState("email");

  const [emailData,
    setEmailData] =
    useState({

      email: "",
      password: ""

    });

  const [phoneData,
    setPhoneData] =
    useState({

      phone: ""
    });

  /* =================================
     EMAIL LOGIN
  ================================= */

  const handleEmailLogin =
    async e => {

      e.preventDefault();

      try {

        const response =
          await dispatch(
            loginAction({

              type: "email",

              email:
                emailData.email,

              password:
                emailData.password

            })
          );
    
        history.push(
          "/crm"
        );

      } catch (error) {

        console.error(
          error
        );
      }
    };

  /* =================================
     PHONE LOGIN
  ================================= */

  const handlePhoneOtp =
    async e => {

      e.preventDefault();

      try {

        const response =
         await dispatch(

  sendOtpAction({

    phone:
      phoneData.phone,

    purpose:
      "login"
  })
);
localStorage.setItem(

  "pendingLogin",

  JSON.stringify(
    phoneData
  )
);

history.push(
  "/verify-otpV2"
);

      } catch (error) {

        console.error(
          error
        );
      }
    };

  return (

   <AuthLayout

  title="Welcome Back"

  subtitle="
  Continue building courses,
  tests and learning experiences.
  "

>


        <h1>
          Login
        </h1>

        {/* Tabs */}

     
          <div className="auth-tabs">

  <button
   onClick={()=>{setTab("email")}}
    className={
      tab === "email"
        ? "active"
        : ""
    }
  >
    Email
  </button>

  <button

  onClick={()=>{setTab("phone")}}
    className={
      tab === "phone"
        ? "active"
        : ""
    }
  >
    Phone
  </button>

</div>


        {/* EMAIL */}

        {tab === "email" && (

          <form
            onSubmit={
              handleEmailLogin
            }
          >

            <input
              type="email"
              placeholder="Email"
              value={
                emailData.email
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  email:
                    e.target.value
                })
              }
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={
                emailData.password
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  password:
                    e.target.value
                })
              }
              required
            />

            <button
             className="auth-btn"
              type="submit"
              disabled={
                loading
              }
            >

              {
                loading
                  ? "Loading..."
                  : "Login"
              }

            </button>

          </form>

        )}

        {/* PHONE */}

        {tab === "phone" && (

          <form
            onSubmit={
              handlePhoneOtp
            }
          >

            <input
              type="text"
              placeholder="Phone Number"
              value={
                phoneData.phone
              }
              onChange={e =>
                setPhoneData({

                  ...phoneData,

                  phone:
                    e.target.value
                })
              }
              required
            />

            <button
             className="auth-btn"
              type="submit"
            >

              Send OTP

            </button>

          </form>

        )}

        <div
          style={{
            marginTop: 20
          }}
        >

          <Link
            to="/forgot-passwordV2"
          >

            Forgot Password?

          </Link>

        </div>

        <div
          style={{
            marginTop: 10
          }}
        >

          <Link
            to="/signupV2"
          >

            Create Account

          </Link>

        </div>


</AuthLayout>
  );
}